<template>
  <div class="clientes">
    <h1 class="titulo-card fs-4">Clientes</h1>
    <div class="form-group card-principal">
      <div class="d-flex justify-content-between">
        <div class="input-group mb-3">
          <button v-on:click="handleAdicionar()" class="btn btn-success">
            <font-awesome-icon :icon="['fas', 'plus']" fixed-width class="me-1"/>Adicionar
          </button>
        </div>

        <div class="input-group mb-3">
          <input
              v-on:keyup.enter="handlePesquisa()"
              type="text"
              class="form-control"
              placeholder="Pesquisar"
              aria-label="Pesquisar"
              aria-describedby="button-addon2">
          <button v-on:click="handlePesquisa()" class="btn btn-outline-secondary" type="button" id="button-addon2">
            <font-awesome-icon :icon="['fas', 'search']" fixed-width class="me-1"/>
          </button>
        </div>
      </div>
      <div class="d-flex">
        <table class="table table-sm-pc table-striped table-hover">
          <thead>
            <tr>
              <th width="25">#</th>
              <th>Nome / razão social</th>
              <th class="d-none d-md-table-cell">Telefone</th>
              <th class="d-none d-md-table-cell">Endereço</th>
              <th width="100"></th>
            </tr>
            </thead>
            <tbody>
              <tr v-for="cliente in listaClientes" :key="cliente.id">
                <td scope="row">{{cliente.id}}</td>
                <td>{{cliente.razao_social}}</td>
                <td class="d-none d-md-table-cell">{{cliente.telefone}}</td>
                <td class="d-none d-md-table-cell">-</td>
                <td class="text-end">
                  <button type="button" v-on:click="handleEditaCliente(cliente)" class="btn btn-primary btn-sm me-1">
                    <font-awesome-icon :icon="['fas', 'edit']" fixed-width/>
                  </button>
                  <button type="button" v-on:click="handleRemoveCliente(cliente)" class="btn btn-danger btn-sm">
                    <font-awesome-icon :icon="['fas', 'times']" fixed-width/>
                  </button>
                </td>

              </tr>
            </tbody>
        </table>
      </div>
      <Paginador v-model="paginador" @change-paginacao="onChangePaginacao"/>
    </div>

    <!-- modal-edita-cliente -->
    <!-- Button trigger modal -->
    <button type="button" class="d-none" data-bs-toggle="modal" data-bs-target="#modal-edita-cliente" id="btn-modal-edita-cliente-abre">
      Launch
    </button>

    <!-- Modal -->
    <div class="modal fade" id="modal-edita-cliente" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
      <div class="modal-dialog modal-xl modal-fullscreen-margin" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 v-if="!modalCliente.data.id" class="modal-title">
              <font-awesome-icon :icon="['fas', 'plus']" fixed-width/>
              Cadastrar novo cliente
            </h5>
            <h5 v-if="!!modalCliente.data.id" class="modal-title">
              <font-awesome-icon :icon="['fas', 'pen']" fixed-width/>
              Editando cliente
            </h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <nav>
              <div class="nav nav-tabs" id="nav-tab" role="tablist">
                <a class="nav-link active" id="nav-principal-tab" data-bs-toggle="tab" href="#nav-principal" role="tab" aria-controls="nav-principal" aria-selected="true">
                  <font-awesome-icon :icon="['far', 'user']" fixed-width/>
                  Dados cadastrais
                </a>
                <a class="nav-link" id="nav-contatos-tab" data-bs-toggle="tab" href="#nav-contatos" role="tab" aria-controls="nav-contatos" aria-selected="false">
                  <font-awesome-icon :icon="['far', 'address-card']" fixed-width/>
                  Contatos
                </a>
                <a class="nav-link" id="nav-enderecos-tab" data-bs-toggle="tab" href="#nav-enderecos" role="tab" aria-controls="nav-enderecos" aria-selected="false">
                  <font-awesome-icon :icon="['fas', 'map-marker-alt']" fixed-width/>
                  Endereços
                </a>
              </div>
            </nav>
            <div class="tab-content" id="nav-tabContent">
              <!-- dados cadastrais -->
              <div class="tab-pane fade show active" id="nav-principal" role="tabpanel" aria-labelledby="nav-principal-tab">
                <div class="row">
                  <div class="col-12 col-sm-4 col-lg-2">
                    <label>Tipo de cadastro</label>
                    <select v-model.number="modalCliente.data.tipo_pessoa" class="form-select">
                      <option value="1">Pessoa física</option>
                      <option value="2">Pessoa jurídica</option>
                    </select>
                  </div>
                  <div v-if="modalCliente.data.tipo_pessoa === 1" class="col-12 col-sm-8 col-lg-10">
                    <label class="required">Nome completo</label>
                    <input type="text" v-model="modalCliente.data.razao_social" class="form-control">
                  </div>
                  <div v-if="modalCliente.data.tipo_pessoa === 2" class="col-12 col-sm-8 col-lg-5">
                    <label class="required">Razão social</label>
                    <input type="text" v-model="modalCliente.data.razao_social" class="form-control">
                  </div>
                  <div v-if="modalCliente.data.tipo_pessoa === 2" class="col-12 col-sm-12 col-lg-5">
                    <label class="required">Nome fantasia</label>
                    <input type="text" v-model="modalCliente.data.nome_fantasia" class="form-control">
                  </div>
                  <div v-if="modalCliente.data.tipo_pessoa === 1" class="col-6 col-sm-6 col-lg-6">
                    <label>CPF</label>
                    <input type="text" v-model="modalCliente.data.cpf_cnpj" class="form-control">
                  </div>
                  <div v-if="modalCliente.data.tipo_pessoa === 2" class="col-6 col-sm-4 col-lg-4">
                    <label>CNPJ</label>
                    <input type="text" v-model="modalCliente.data.cpf_cnpj" class="form-control">
                  </div>
                  <div v-if="modalCliente.data.tipo_pessoa === 1" class="col-6 col-sm-6 col-lg-6">
                    <label>RG</label>
                    <input type="text" v-model="modalCliente.data.rg_ie" class="form-control">
                  </div>
                  <div v-if="modalCliente.data.tipo_pessoa === 2" class="col-6 col-sm-4 col-lg-4">
                    <label>Inscrição Estadual</label>
                    <input type="text" v-model="modalCliente.data.rg_ie" class="form-control">
                  </div>
                  <div v-if="modalCliente.data.tipo_pessoa === 2" class="col-12 col-sm-4 col-lg-4">
                    <label>Inscrição Municipal</label>
                    <input type="text" v-model="modalCliente.data.inscricao_municipal" class="form-control">
                  </div>
                </div>
              </div>
              <!-- dados cadastrais -->

              <!-- contatos -->
              <div class="tab-pane fade" id="nav-contatos" role="tabpanel" aria-labelledby="nav-contatos-tab">
                <div class="row">
                  <div class="col-12 col-sm-6">
                    <label>E-mail</label>
                    <input type="text" v-model="modalCliente.data.email" class="form-control">
                  </div>
                  <div class="col-12 col-sm-6">
                    <label>Telefone</label>
                    <input type="text" v-model="modalCliente.data.telefone" class="form-control">
                  </div>
                  <div class="col-12">
                    <label>Outros</label>
                    <textarea v-model="modalCliente.data.outros_contatos" rows="4" maxlength="100" class="form-control"></textarea>
                  </div>
                </div>
              </div>
              <!-- contatos -->

              <!-- endereços -->
              <div class="tab-pane fade" id="nav-enderecos" role="tabpanel" aria-labelledby="nav-enderecos-tab">
                <div class="row">
                  <div class="col-12">
                    <table class="table table-sm table-stripped">
                      <thead>
                        <tr>
                          <th>Endereços</th>
                          <th width="82"></th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="endereco in modalCliente.data.enderecos" :key="endereco.id">
                          <td scope="row">{{formataEndereco(endereco)}}</td>
                          <td class="text-end">
                            <button type="button" v-on:click="handleModalClienteEditaEndereco(endereco)" class="btn btn-primary btn-sm me-1">
                              <font-awesome-icon :icon="['fas', 'pen']"/>
                            </button>
                            <button type="button" v-on:click="handleModalClienteRemoveEndereco(endereco)" class="btn btn-danger btn-sm">
                              <font-awesome-icon :icon="['fas', 'times']"/>
                            </button>
                          </td>
                        </tr>
                        <tr v-if="!modalCliente.data.enderecos.length">
                          <td class="small" colspan="2">Nenhum endereço cadastrado</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div class="col-12 mt-3">
                    <hr>
                    <h6 class="small text-info">
                      <font-awesome-icon :icon="['fas', 'plus']" fixed-width/>
                      Novo / editar
                    </h6>
                  </div>
                  <div class="col-6 col-sm-3 col-md-2">
                    <label>CEP</label>
                    <input type="text" v-model="modalCliente.editEndereco.cep" maxlength="9" class="form-control">
                  </div>
                  <div class="col-6 col-sm-9 col-md-5">
                    <label class="required">Logradouro</label>
                    <input type="text" v-model="modalCliente.editEndereco.logradouro" class="form-control">
                  </div>
                  <div class="col-6 col-sm-3 col-md-2">
                    <label>Número</label>
                    <input type="text" v-model="modalCliente.editEndereco.numero" class="form-control">
                  </div>
                  <div class="col-6 col-sm-3 col-md-3">
                    <label>Complemento</label>
                    <input type="text" v-model="modalCliente.editEndereco.complemento" class="form-control">
                  </div>
                  <div class="col-6 col-md-4">
                    <label class="required">Bairro</label>
                    <input type="text" v-model="modalCliente.editEndereco.bairro" class="form-control">
                  </div>
                  <div class="col-6 col-sm-6 col-md-4">
                    <label class="required">Cidade</label>
                    <input type="text" v-model="modalCliente.editEndereco.cidade" class="form-control">
                  </div>
                  <div class="col-12 col-sm-6 col-md-4">
                    <label class="required">Estado</label>
                    <select v-model="modalCliente.editEndereco.uf" class="form-select">
                      <option disabled value="undefined">Selecione</option>
                      <option value="MG">Minas Gerais</option>
                      <option disabled value="DESATIVADO">Outros (solicite ativação)</option>
                    </select>
                  </div>
                  <div class="col-12 text-end mt-2">
                    <button type="button"
                        v-if="!!modalCliente.editEndereco.id"
                        v-on:click="handleModalClienteCancelaEdicaoEndereco()"
                        class="btn btn-outline-secondary me-2">
                      Cancelar
                    </button>
                    <button type="button"
                        v-if="!modalCliente.editEndereco.id"
                        v-on:click="handleModalClienteAdicionaEndereco()"
                        v-bind:disabled="!podeSalvarEndereco()"
                        class="btn btn-outline-primary">
                      <font-awesome-icon :icon="['fas', 'plus']"/>
                      Adicionar
                    </button>
                    <button type="button"
                        v-if="!!modalCliente.editEndereco.id"
                        v-on:click="handleModalClienteSalvaEndereco()"
                        v-bind:disabled="!podeSalvarEndereco()"
                        class="btn btn-outline-primary">
                      <font-awesome-icon :icon="['fas', 'check']"/>
                      Salvar
                    </button>
                  </div>
                </div>
              </div>
              <!-- endereços -->
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-outline-secondary" data-bs-dismiss="modal" id="btn-modal-edita-cliente-fecha">Fechar</button>
            <button type="button"
                v-if="!modalCliente.data.id"
                v-on:click="handleModalClienteCadastrar()"
                v-bind:disabled="!podeSalvarCliente()"
                class="btn btn-success">
              Cadastrar
            </button>
            <button type="button"
                v-if="!!modalCliente.data.id"
                v-on:click="handleModalClienteSalvar()"
                v-bind:disabled="!podeSalvarCliente()"
                class="btn btn-success">
              Salvar
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- modal-edita-cliente -->
  </div>
</template>

<script>
import Paginador from '@/components/Paginador.vue'
import api from '@/modules/api'
import dialogo from '@/modules/dialogo'
import loading from '@/modules/loading'
import clone from '@/modules/clone'
import model from '@/model'

export default {
  name: 'Clientes',
  components: {
    Paginador,
  },
  data() {
    return {
      /** @type {model.paginador} */
      paginador: clone(model.paginador),
      listaClientes: [],
      modalCliente: {
        data: {
          id: undefined,
          tipo_pessoa: 1,
          razao_social: '',
          nome_fantasia: '',
          cpf_cnpj: '',
          rg_ie: '',
          inscricao_municipal: '',
          email: '',
          telefone: '',
          outros_contatos: '',
          enderecos: [],
        },
        editEndereco: {
          id: undefined,
          cep: '',
          logradouro: '',
          numero: '',
          complemento: '',
          bairro: '',
          cidade: '',
          uf: undefined,
        }
      }
    }
  },
  methods: {
    handlePesquisa() {
      loading(true);

      api.get(`/clientes?${this.paginador.requestParams}`).then(res => {
        loading(false);
        this.listaClientes = res.data.itens;
        this.paginador.pagina = res.data.paginacao.pagina;
        this.paginador.totalItens = res.data.paginacao.total;
      }).catch(error => {
        loading(false);
        dialogo.erroHttp(error);
      });
    },

    onChangePaginacao() {
      this.handlePesquisa();
    },

    handleAdicionar() {
      this.abreModalCadastroCliente();
    },

    async handleEditaCliente(cliente) {
      this.resetModalCliente();

      if (!cliente.enderecos) {
        await this.carregaEnderecosCliente(cliente).catch(() => {
          return;
        });
      }

      this.modalCliente.data = clone(cliente);

      document.getElementById('btn-modal-edita-cliente-abre').click();
    },

    handleRemoveCliente(cliente) {
      dialogo.confirmacao(`Confirma remover o cliente <b>${cliente.razao_social}</b>?`).then(() => {
        loading(true);

        api.delete(`/clientes/${cliente.id}`).then(() => {
          loading(false);

          this.handlePesquisa();
        }).catch(error => {
          loading(false);
          dialogo.erroHttp(error);
        });
      });
    },

    abreModalCadastroCliente() {
      this.resetModalCliente();
      document.getElementById('btn-modal-edita-cliente-abre').click();
    },

    resetModalCliente() {
      this.modalCliente.data.id = undefined;
      this.modalCliente.data.tipo_pessoa = 1;
      this.modalCliente.data.razao_social = '';
      this.modalCliente.data.nome_fantasia = '';
      this.modalCliente.data.cpf_cnpj = '';
      this.modalCliente.data.rg_ie = '';
      this.modalCliente.data.inscricao_municipal = '';
      this.modalCliente.data.email = '';
      this.modalCliente.data.telefone = '';
      this.modalCliente.data.outros_contatos = '';

      this.modalCliente.data.enderecos = [];

      this.resetModalEditEndereco();
    },

    resetModalEditEndereco() {
      this.modalCliente.editEndereco.id = undefined;
      this.modalCliente.editEndereco.cep = '';
      this.modalCliente.editEndereco.logradouro = '';
      this.modalCliente.editEndereco.numero = '';
      this.modalCliente.editEndereco.complemento = '';
      this.modalCliente.editEndereco.bairro = '';
      this.modalCliente.editEndereco.cidade = '';
      this.modalCliente.editEndereco.uf = undefined;
    },

    podeSalvarCliente() {
      switch (true) {
        case (3 > this.modalCliente.data.razao_social.length):
        case (2 === this.modalCliente.data.tipo_pessoa && 3 > this.modalCliente.data.nome_fantasia.length):
          return false;

        default:
          return true;
      }
    },

    podeSalvarEndereco() {
      switch (true) {
          case (3 > this.modalCliente.editEndereco.logradouro.length):
          case (3 > this.modalCliente.editEndereco.bairro.length):
          case (3 > this.modalCliente.editEndereco.cidade.length):
          case (!this.modalCliente.editEndereco.uf):
            return false;

          default:
            return true;
      }
    },

    handleModalClienteAdicionaEndereco() {
      this.modalCliente.data.enderecos.push({...this.modalCliente.editEndereco});
      this.resetModalEditEndereco();
    },

    handleModalClienteSalvaEndereco() {
      if (!this.modalCliente.editEndereco.id) {
        this.resetModalEditEndereco();
        return;
      }

      const id = this.modalCliente.editEndereco.id;
      const endereco = this.modalCliente.data.enderecos.find(e => id === e.id);
      const i = this.modalCliente.data.enderecos.indexOf(endereco);

      if (i >= 0) {
        this.modalCliente.data.enderecos[i] = clone(this.modalCliente.editEndereco);
      }

      this.resetModalEditEndereco();
    },

    handleModalClienteCancelaEdicaoEndereco() {
      this.resetModalEditEndereco();
    },

    handleModalClienteEditaEndereco(endereco) {
      this.modalCliente.editEndereco = clone(endereco);
    },

    handleModalClienteRemoveEndereco(endereco) {
      dialogo.confirmacao(`Confirma remover o endereço <b>${this.formataEndereco(endereco)}</b>?`).then(() => {
        const i = this.modalCliente.data.enderecos.indexOf(endereco);

        if (i >= 0) {
          this.modalCliente.data.enderecos.splice(i, 1);
        }
      });
    },

    handleModalClienteCadastrar() {
      const sendData = {...this.modalCliente.data};

      loading(true);

      api.post('/clientes', sendData).then(() => {
        loading(false);
        document.getElementById('btn-modal-edita-cliente-fecha').click();
        this.handlePesquisa();
      }).catch(error => {
        loading(false);
        dialogo.erroHttp(error);
      });
    },

    handleModalClienteSalvar() {
      const sendData = {...this.modalCliente.data};

      sendData.nome = sendData.razao_social;

      loading(true);
      api.put(`/clientes/${sendData.id}`, sendData).then(() => {
        loading(false);
        document.getElementById('btn-modal-edita-cliente-fecha').click();
        this.handlePesquisa();
      }).catch(error => {
        loading(false);
        dialogo.erroHttp(error);
      });
    },

    async carregaEnderecosCliente(cliente) {
      loading(true);

      return await api.get(`/clientes/${cliente.id}/enderecos`).then(res => {
        cliente.enderecos = res.data;
        loading(false);
      }).catch(error => {
        loading(false);
        dialogo.erroHttp(error);
      });
    },

    //TODO: fazer esta função ser global
    formataEndereco(endereco) {
      let resultado = '';

      // resultado += `${endereco.id} - `;
      resultado += endereco.logradouro;

      if (endereco.numero) {
        resultado += `, ${endereco.numero}`;
      }

      if (endereco.complemento) {
        resultado += ` ${endereco.complemento}`;
      }

      resultado += ` - ${endereco.bairro}`;
      resultado += ` - ${endereco.cidade}`;
      resultado += ` - ${endereco.uf}`;

      return resultado;
    },
  },
  created() {
    this.handlePesquisa();

    // document.getElementById('btn-modal-edita-cliente-fecha').click();
    /*
    setTimeout(() => {
      this.handleAdicionar();

      this.modalCliente.data.tipo_pessoa = 2;
      this.modalCliente.data.razao_social = 'Razão social';
      this.modalCliente.data.nome_fantasia = 'Nome fantasia';
      this.modalCliente.data.email = 'mail@mail.com';
      this.modalCliente.data.telefone = '(31) 98695-0236';
      this.modalCliente.data.outros_contatos = 'telegram: asdf1fawefa654';

      this.modalCliente.editEndereco.cep = '35171-052';
      this.modalCliente.editEndereco.logradouro = 'Rua Alvino Olegário';
      this.modalCliente.editEndereco.numero = '107 A';
      this.modalCliente.editEndereco.complemento = '3º andar';
      this.modalCliente.editEndereco.bairro = 'Alipinho';
      this.modalCliente.editEndereco.cidade = 'Coronel Fabriciano';
      this.modalCliente.editEndereco.uf = 'MG';

      this.handleModalClienteAdicionaEndereco();

      this.modalCliente.editEndereco.cep = '35171-026';
      this.modalCliente.editEndereco.logradouro = 'Rua Tungstênio';
      this.modalCliente.editEndereco.numero = '97';
      this.modalCliente.editEndereco.complemento = '';
      this.modalCliente.editEndereco.bairro = 'Recanto Verde';
      this.modalCliente.editEndereco.cidade = 'Coronel Fabriciano';
      this.modalCliente.editEndereco.uf = 'MG';

      this.handleModalClienteAdicionaEndereco();

      this.modalCliente.data.tipo_pessoa = 1;
      this.modalCliente.data.razao_social = 'Leonardo Getúlio Vieira Moutinho';
      this.modalCliente.data.nome_fantasia = '';
      this.modalCliente.data.cpf_cnpj = '088.338.326-86';
      this.modalCliente.data.rg_ie = '15.515.382';
    }, 500);
    */
  }
}
</script>
